import type { ScheduledDetailedCopy } from './scheduled-page-copy-translations';

export const scheduledDetailedCopyHindi = {
  hi: {
    status: {
      upcoming: 'आगामी',
      running: 'चल रहा है',
      waitingBackground: 'बैकग्राउंड कार्य की प्रतीक्षा',
      succeeded: 'सफल',
      failed: 'विफल',
      skipped: 'छोड़ा गया',
      needsAttention: 'ध्यान देना आवश्यक',
      unknownOutcome: 'परिणाम अज्ञात',
      canceled: 'रद्द',
      malformed: 'उपलब्ध नहीं',
      paused: 'रोका गया',
    },
    editor: {
      createTitle: 'नया शेड्यूल',
      editTitle: 'शेड्यूल संपादित करें',
      description: 'कार्य, समय, संदर्भ और बिना निगरानी वाली अनुमति तय करें।',
      stepOf: '4 में से चरण {step}',
      task: 'कार्य',
      timing: 'समय',
      execution: 'निष्पादन',
      review: 'समीक्षा',
      name: 'शेड्यूल का नाम',
      namePlaceholder: 'जैसे सोमवार की प्रदर्शन रिपोर्ट',
      instructions: 'एजेंट के निर्देश',
      instructionsPlaceholder:
        'बताएँ कि एजेंट को क्या परिणाम देना है और वह कहाँ कार्रवाई कर सकता है।',
      sourceChat: 'स्रोत चैट',
      scheduleThisChat: 'इस चैट को शेड्यूल करें',
      sourceSnapshot:
        'सहेजते समय एक निजी स्नैपशॉट लिया जाता है। बाद के चैट बदलाव इस शेड्यूल को नहीं बदलेंगे।',
      sourceUnavailable:
        'स्रोत चैट उपलब्ध नहीं है या अब आपके पास उसकी पहुँच नहीं है।',
      sourceChatLockedNote:
        'स्रोत चैट का दोबारा उपयोग करने वाले शेड्यूल में संदर्भ स्थायी और दृश्यता निजी रहनी चाहिए।',
      recurrence: 'दोहराव',
      once: 'एक बार',
      hourly: 'हर घंटे',
      daily: 'प्रतिदिन',
      weekdays: 'कार्यदिवस',
      selectedWeekdays: 'चुने हुए सप्ताह के दिन',
      weekly: 'साप्ताहिक',
      monthly: 'मासिक',
      date: 'तारीख',
      time: 'स्थानीय समय',
      dayOfMonth: 'महीने का दिन',
      whenPlaceholder: 'YYYY-MM-DD',
      whenInvalid: 'तारीख YYYY-MM-DD प्रारूप में लिखें।',
      end: 'समाप्ति',
      never: 'कभी नहीं',
      onDate: 'किसी तारीख को',
      afterOccurrences: 'निश्चित संख्या में रन के बाद',
      occurrences: 'रन',
      nextRuns: 'अगले रन',
      schedulePreview: 'शेड्यूल पूर्वावलोकन',
      noEndDate: 'समाप्ति तिथि नहीं है।',
      runsUntil: '{date} तक चलेगा।',
      totalRuns: 'कुल {count} रन।',
      resolvingTime: 'सर्वर इस स्थानीय समय की जाँच कर रहा है…',
      serverTimeRequired:
        'सहेजने से पहले सर्वर को इस स्थानीय समय की पुष्टि करनी होगी।',
      contextMode: 'चैट संदर्भ',
      persistent: 'स्थायी संदर्भ',
      persistentDescription:
        'सभी रन में शेड्यूल के स्वामित्व वाली एक चैट का फिर उपयोग करें।',
      isolated: 'हर रन के लिए नई चैट',
      isolatedDescription: 'हर रन को अलग संदर्भ से शुरू करें।',
      visibility: 'दृश्यता',
      private: 'निजी',
      privateDescription:
        'पूरा प्रॉम्प्ट, वार्तालाप, टूल गतिविधि और परिणाम केवल आपको दिखाई देंगे।',
      workspace: 'वर्कस्पेस',
      workspaceWarning:
        'वर्कस्पेस में साझा करने पर पूरा प्रॉम्प्ट, वार्तालाप, टूल गतिविधि और परिणाम दिखाई देंगे।',
      creditPolicy: 'वर्कस्पेस क्रेडिट नीति',
      creditsAvailable:
        'रन वर्कस्पेस के मौजूदा क्रेडिट बैलेंस और सीमाओं का उपयोग करते हैं।',
      creditsUnavailable:
        'इस वर्कस्पेस में अभी क्रेडिट उपलब्ध नहीं हैं। रन के समय शेड्यूल रुक सकता है।',
      fullAuthorityTitle: 'एजेंट की कार्रवाइयाँ',
      fullAuthorityDescription:
        'हर रन में एजेंट आपकी मौजूदा पहुँच दोबारा जाँचता है और बिना पूछे विनाशकारी कार्रवाई कर सकता है।',
      authorityAcknowledgment: 'पहले पूछे बिना किसी भी कार्रवाई की अनुमति दें।',
      authorityRequired:
        'यह शेड्यूल बनाने के लिए एजेंट कार्रवाइयों की अनुमति दें। रन बिना निगरानी के चलते हैं, इसलिए बाद में कोई उन्हें स्वीकृत नहीं कर सकता।',
      recurrenceUnresolved:
        'यह रन समय सत्यापित नहीं हो सका। तारीख और समय फिर से चुनें।',
      notifications: 'ऐप में सूचनाएँ',
      notificationsDescription:
        'ध्यान देने योग्य अंतिम परिणामों के लिए आपको एक बार सूचना मिलेगी।',
      reviewSummary:
        'शेड्यूल बनाने से पहले सही कार्य और आवृत्ति की समीक्षा करें।',
      required: 'यह फ़ील्ड आवश्यक है।',
      invalid: 'मान्य मान दर्ज करें।',
      past: 'भविष्य का समय चुनें।',
      endBeforeStart: 'शेड्यूल को उसके पहले रन के बाद समाप्त करें।',
      draftRestored: 'आपका सहेजा न गया ड्राफ़्ट पुनर्स्थापित कर दिया गया।',
      tooLong: 'यह मान बहुत लंबा है।',
      createDisabled: 'आपको इस वर्कस्पेस में शेड्यूल बनाने की अनुमति नहीं है।',
      saved: 'शेड्यूल सहेजा गया',
      unsavedTitle: 'न सहेजे गए बदलाव छोड़ें?',
      unsavedDescription: 'अभी बंद करने पर इस शेड्यूल के बदलाव खो जाएँगे।',
      discardChanges: 'बदलाव छोड़ें',
    },
    detail: {
      title: 'शेड्यूल का विवरण',
      cadence: 'आवृत्ति',
      owner: 'स्वामी',
      timezone: 'समय क्षेत्र',
      nextRun: 'अगला रन',
      lastRun: 'पिछला रन',
      prompt: 'पूरा प्रॉम्प्ट',
      sourceContext: 'सहेजा गया स्रोत संदर्भ',
      executionMode: 'निष्पादन मोड',
      recentUsage: 'हाल का उपयोग',
      credits: 'क्रेडिट',
      tools: 'कार्रवाइयाँ',
      history: 'रन का इतिहास',
      transcript: 'बातचीत',
      resultFiles: 'परिणाम फ़ाइलें',
      noResultFiles: 'इस रन के लिए कोई परिणाम फ़ाइल दर्ज नहीं की गई।',
      noRuns: 'अभी कोई रन नहीं है।',
      noTranscript: 'इस रन के लिए अभी कोई वार्तालाप उपलब्ध नहीं है।',
      toolActivity: 'गतिविधि',
      toolInput: 'कार्य का विवरण',
      toolResult: 'नतीजा',
      noToolActivity: 'इस रन के लिए कोई गतिविधि उपलब्ध नहीं है।',
      loadMore: 'और लोड करें',
      preview: 'पूर्वावलोकन',
      sourceScheduled: 'शेड्यूल किया गया',
      sourceManual: 'मैन्युअल',
      sourceWatchdog: 'पुनर्प्राप्ति',
      roleUser: 'उपयोगकर्ता',
      roleAssistant: 'सहायक',
      roleTool: 'टूल',
      roleSystem: 'सिस्टम',
      runNow: 'अभी चलाएँ',
      pause: 'रोकें',
      resume: 'फिर शुरू करें',
      share: 'वर्कस्पेस के साथ साझा करें',
      unshare: 'निजी बनाएँ',
      cancelRun: 'सक्रिय रन रद्द करें',
      archive: 'संग्रहीत करें',
      deleteSchedule: 'शेड्यूल हटाएँ',
      openThread: 'थ्रेड देखें',
      confirmArchive: 'इस शेड्यूल को संग्रहीत करें?',
      confirmArchiveDescription:
        'भविष्य का काम रद्द हो जाएगा। इतिहास और ऑडिट रिकॉर्ड सुरक्षित रहेंगे।',
      confirmDelete: 'यह शेड्यूल हटाएँ?',
      confirmDeleteDescription:
        'यह शेड्यूल स्थायी रूप से हट जाएगा। पिछली बातचीत और बनाया गया काम वर्कस्पेस में रहेगा।',
      confirmUnshareDescription:
        'वर्कस्पेस सदस्य तुरंत प्रॉम्प्ट, ट्रांसक्रिप्ट, टूल गतिविधि और परिणाम की पहुँच खो देंगे।',
      confirmCancel: 'सक्रिय रन रद्द करें?',
      confirmCancelDescription: 'रन अगले सुरक्षित रद्दीकरण बिंदु पर रुक जाएगा।',
      actionCompleted: 'शेड्यूल अपडेट किया गया',
      permissionDenied:
        'आप इस शेड्यूल को देख सकते हैं, लेकिन केवल स्वामी या शेड्यूल व्यवस्थापक इसे बदल सकता है।',
      needsAttention:
        'बिना निगरानी का काम जारी रखने से पहले इस रन की समीक्षा आवश्यक है।',
      runDetails: 'रन का विवरण',
    },
    notifications: {
      completed: 'शेड्यूल किया गया रन पूरा हुआ',
      failed: 'शेड्यूल किया गया रन विफल हुआ',
      attention: 'शेड्यूल किए गए रन पर ध्यान देना आवश्यक है',
      missed: 'एक बार वाला शेड्यूल रन छूट गया',
      viewRun: 'रन देखें',
      empty: 'अभी तक कोई रन सूचना नहीं है।',
      unread: 'अपठित',
      read: 'पढ़ा गया',
      caughtUp: 'आपने सभी सूचनाएँ देख ली हैं।',
    },
    errors: {
      generic: 'कुछ गलत हुआ। फिर कोशिश करें।',
      permission: 'आपको यह कार्रवाई करने की अनुमति नहीं है।',
      disabled: 'इस वर्कस्पेस में शेड्यूल एजेंट अभी सक्षम नहीं हैं।',
      credits: 'वर्कस्पेस में पर्याप्त क्रेडिट नहीं हैं।',
      limit: 'वर्कस्पेस सक्रिय शेड्यूल की सीमा तक पहुँच गया है।',
      runPending: 'इस शेड्यूल के लिए एक रन पहले से लंबित है या चल रहा है।',
      invalidTime: 'भविष्य का कोई मान्य समय चुनें।',
      notFound: 'यह शेड्यूल या रन अब उपलब्ध नहीं है।',
    },
  },
} satisfies Record<'hi', ScheduledDetailedCopy>;
